var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11203_64800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4951 6.07422C11.4951 6.07422 6.64834 6.07422 5.43186 6.39032C4.78052 6.57231 4.24419 7.10865 4.06219 7.76957C3.7461 8.98605 3.74609 11.5053 3.74609 11.5053C3.74609 11.5053 3.7461 14.0341 4.06219 15.2314C4.24419 15.8923 4.77094 16.4191 5.43186 16.6011C6.65792 16.9267 11.4951 16.9267 11.4951 16.9267C11.4951 16.9267 16.3515 16.9267 17.568 16.6106C18.2289 16.4287 18.7556 15.9115 18.928 15.241C19.2537 14.0341 19.2537 11.5149 19.2537 11.5149C19.2537 11.5149 19.2633 8.98605 18.928 7.76957C18.7556 7.10865 18.2289 6.5819 17.568 6.40949C16.3515 6.07423 11.4951 6.07422 11.4951 6.07422ZM9.95295 9.17772L13.9856 11.5053L9.95295 13.8232V9.17772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11203_64800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.1396b85d02de8751a7609548081b07db.svg";
export { ForwardRef as ReactComponent };